import { Route, Switch } from 'wouter';
import { Home } from './routes/Home.js';
import { Test } from './routes/Test.js';
import { Done } from './routes/Done.js';
import { Review } from './routes/Review.js';
import { Settings } from './routes/Settings.js';

export function App(): JSX.Element {
  return (
    <div className="h-dvh flex flex-col overflow-hidden bg-canvas text-primary">
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/test/:contentId" component={Test} />
        <Route path="/done/:contentId" component={Done} />
        <Route path="/review" component={Review} />
        <Route path="/settings" component={Settings} />
        <Route>
          <div className="flex-1 flex items-center justify-center text-secondary">404</div>
        </Route>
      </Switch>
    </div>
  );
}
